<template>
	<div class="text-xs-center">
		<v-menu v-model="menu" :close-on-content-click="false" offset-y>
			<template v-slot:activator="{ on }">
				<v-btn color="yellow darken-3" outline v-on="on"
					>Alternate Transform</v-btn
				>
			</template>

			<v-card flat>
				<v-card-text>
					<v-form ref="form" v-model="valid" lazy-validation>
						<v-select
							required
							:items="modeItems"
							v-model="mode"
							label="Tranformer Mode"
						></v-select>
						<v-select
							disabled
							required
							:items="streamModeItems"
							v-model="streamMode"
							label="Stream Mode"
						></v-select>
						<v-checkbox
							disabled
							v-model="splitText"
							label="Split Text"
						></v-checkbox>
						<v-checkbox
							disabled
							v-model="replaceNewLine"
							label="Replace new line"
						></v-checkbox>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="menu = false">Cancel</v-btn>
					<v-btn color="orange darken-3" flat @click="validate"
						>Get Alternate</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-menu>
	</div>
</template>

<script>
export default {
	/* parserConfig: {
					            mode: "camelot", // or mode 'tabula'
					            streamMode: "lattice", //default stream mode
					            splitText: true, //optional
					            replaceNewLine: true //optional
					        } */
	data: () => ({
		menu: false,
		valid: true,
		mode: 'pdftotext',
		modeItems: [
			{ text: 'Transform v2', value: 'transformv2' },
			{ text: 'PDF TO TEXT', value: 'pdftotext' },
			// { text: "Tabula", value: "tabula" },
			// { text: "Camelot", value: "camelot" }
		],
		streamMode: 'stream',
		streamModeItems: [
			{ text: 'Stream', value: 'stream' },
			{ text: 'Lattice', value: 'lattice' },
		],
		splitText: false,
		replaceNewLine: false,
		headRowIndex: 0,
		footRowIndex: false,
	}),
	props: ['value'],
	methods: {
		validate() {
			if (this.$refs.form.validate()) {
				let formData = {
					enabled: 1,
					mode: this.mode,
					streamMode: this.streamMode,
					splitText: this.splitText,
					replaceNewLine: this.replaceNewLine,
					headRowIndex: this.headRowIndex,
					footRowIndex: this.footRowIndex,
				};
				// console.log(formData);
				this.$emit('input', formData);
				this.menu = false;
			}
		},
		reset() {
			this.$refs.form.reset();
		},
	},
};
</script>
